<template>
    <SlideYDownTransition :duration="250">
        <div 
            class="dropdown-menu" 
            aria-labelledby="dropdownMenuButton"
            :class="[{'show': show}, {'d-none': !show}]"
            v-show="show"
        >
            <button
                v-for="(item, i) in items"
                :key="i" 
                class="btn btn-link dropdown-item"
                @click="$emit('onSelect', item)"
            >{{ item.name }}</button>
        </div>
    </SlideYDownTransition>
</template>

<script>
import { SlideYDownTransition } from 'vue2-transitions'

export default {
    emits: ['input', 'onSelect', 'update:modelValue'],
    name: 'Dropdown',
    components: {
        SlideYDownTransition
    },
    props: {
        modelValue: {
            type: Boolean,
            required: true
        },
        items: {
            type: Array,
            required: true
        }
    },
    computed: {
        show: {
            get() {
                return this.modelValue
            },
            set(value) {
                this.$emit('update:modelValue', value);
                this.$emit('input', value);
            }
        }
    },
    methods: {
        closeDropdown() {
            this.show = false
        }
    }
}
</script>

<style>
</style>
